const BASE_URL = "https://a.klaviyo.com";
const BIS_ENDPOINT = "/client/back-in-stock-subscriptions";
const LIST_ENDPOINT = "/client/subscriptions/";

class Klaviyo {
	constructor() {
		this.publicKey = window.klaviyo.key;
	}
	  
	backInStockSubscribe({ email, variant, subscribe = false }) {
		return new Promise((resolve, reject) => {
			const payload = {
				data: {
				  type: 'back-in-stock-subscription',
				  attributes: {
					channels: ['EMAIL'],
					profile: {data: {type: 'profile', attributes: {email}}}
				  },
				  relationships: {
					variant: {data: {type: 'catalog-variant', id: `$shopify:::$default:::${ variant }`}}
				  }
				}
			  };

			try {
				fetch(`${ BASE_URL }${ BIS_ENDPOINT }?company_id=${ this.publicKey }`, {
					method: "post",
					headers: {
						accept: 'application/json',
						revision: '2024-05-15',
						'content-type': 'application/json'
					},
					body: JSON.stringify(payload)
				})
				.then((data) => {
					resolve(data);
				});
			} catch (e) {
				reject(e);
			}
		});
	}
}
